<div class="max-w-screen-sm bg-white">
  <div
    class="flex items-center justify-between"
    (click)="toggleAccordion()"
  >
    <h2 class="inline-block font-accent text-md font-bold leading-6">
      {{ scheduleHeader() }}
    </h2>
    <button class="icon icon-arrow-down-s {{ isAccordionActive() ? 'close' : '' }}"></button>
  </div>
  <div
    [@isAccordionActive]="isAccordionActive() ? { value: 'visible' } : { value: 'hidden' }"
    class="pt-4"
  >
    @for (schedule of groupedSchedules(); track schedule) {
      <div
        class="flex items-start gap-3 border-b border-neutral-300 py-2.5"
        [class.font-bold]="schedule.isToday"
      >
        <div class="w-20 pt-1 leading-4.5">
          {{ schedule.day.name | translate }}
        </div>
        <ng-container
          *ngTemplateOutlet="timeSlotsTemplate; context: { schedule: schedule }"
        ></ng-container>
        @if (schedule.status !== 'open') {
          <ng-container
            *ngTemplateOutlet="scheduleStatusTemplate; context: { schedule: schedule }"
          ></ng-container>
        }
      </div>
    }
  </div>
</div>

@if (calendarPerturbationsAfterToday().length) {
  <div class="max-w-screen-sm border-t border-neutral-300 bg-white pt-5">
    <div
      class="flex items-center justify-between"
      (click)="toggleAccordionCalendarPerturbation()"
    >
      <h2 class="font-accent text-md font-bold leading-6">
        <span class="mr-3 pt-1">{{ 'shop-informations.schedulePerturbations' | translate }}</span>
        <div class="min-w-fit whitespace-nowrap pt-2 capitalize">
          <span class="mr-3 text-neutral-600">{{ firstPerturbationsAfterToday().dateText }} </span>
          @let text =
            'shop-informations.scheduleStatus.' + firstPerturbationsAfterToday().status | translate;
          <div class="inline-block">
            <app-tag-atom
              [color]="firstPerturbationsAfterToday().statusColor"
              [text]="text"
            ></app-tag-atom>
          </div>
        </div>
      </h2>
      <button
        class="icon icon-arrow-down-s {{ isCalendarPerturbationAccordionActive() ? 'close' : '' }}"
      ></button>
    </div>
    <div
      [@isAccordionActive]="
        isCalendarPerturbationAccordionActive() ? { value: 'visible' } : { value: 'hidden' }
      "
      class="{{ isCalendarPerturbationAccordionActive() ? 'pt-4' : '' }}"
    >
      <div
        class="grid grid-cols-3 gap-4 overflow-hidden"
        [style.gridTemplateColumns]="'auto auto 1fr!important'"
      >
        @for (
          schedule of calendarPerturbationsAfterToday();
          track schedule.date;
          let even = $even
        ) {
          <div class="pt-1 capitalize leading-4.5">
            {{ schedule.dateText }}
          </div>
          <ng-container
            *ngTemplateOutlet="timeSlotsTemplate; context: { schedule: schedule }"
          ></ng-container>
          @if (schedule.status !== 'open') {
            <ng-container
              *ngTemplateOutlet="scheduleStatusTemplate; context: { schedule: schedule }"
            ></ng-container>
          }
        }
      </div>
    </div>
  </div>
}

<ng-template
  #timeSlotsTemplate
  let-schedule="schedule"
>
  @if (schedule.timeSlots.length) {
    <ul class="flex flex-col items-start self-stretch pt-1">
      @for (timeSlot of schedule.timeSlots; track $index; let i = $index, last = $last) {
        <li class="text-neutral-600 leading-4.5 {{ last ? 'mb-0' : 'mb-2' }}  flex flex-row gap-3">
          <span
            [class.line-through]="timeSlot.isClosed"
            class="whitespace-nowrap"
          >
            {{ getHours(timeSlot.start) }}—{{ getHours(timeSlot.end) }}
          </span>

          @if (isShopMoveable()) {
            <div>
              {{ timeSlot.address }}
            </div>
          }
          @for (
            distributionMode of timeSlot.allowed_distribution_modes ?? [];
            track distributionMode
          ) {
            <div class="ml-2 rounded border bg-neutral-50 px-1 text-sm font-bold">
              {{ 'distribution-modes.' + distributionMode | translate }}
            </div>
          }
        </li>
      }
    </ul>
  }
</ng-template>

<ng-template
  #scheduleStatusTemplate
  let-schedule="schedule"
>
  <div class="flex items-start self-stretch text-neutral-600">
    @let text = 'shop-informations.scheduleStatus.' + schedule.status | translate;
    @if (schedule.status === 'closed') {
      <span class="flex items-center self-stretch pt-1 leading-4.5">{{ text }}</span>
    } @else {
      <app-tag-atom
        [color]="schedule.statusColor"
        [text]="text"
      ></app-tag-atom>
    }
  </div>
</ng-template>
